import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { RequireStudent } from '../middlewares/HOC';
import PATHS from './PATHS';

import {
    UserMockExam, UserFreqExam, UserExamReview, UserExamCorrection,
    PublicBadgeRelease, PublicCertAttendRelease, UserInteractiveBookDetails,
} from '../pages';

/*
 * The landing pages a signed-in reader can reach, taken from the same bridge
 * the signed-out router uses, so each URL has one answer whichever router asks.
 */
import { Catalogue, CertificateDetails, ContactUs, PrivacyPolicy, TermsAndConditions } from './landingScreens';
import {
    CourseDetails, Dashboard, EssaysBank, ExamResults, FileBank, KnowledgeTest, McqsBank, Profile, Subscriptions, TbsBank,
} from './studentScreens';

const StudentStack = () => {

    return <Switch>

        {/* The old course list and the old performance and exams-log pages.
            The course list is the catalogue now; the other two are tabs of the
            course page, for the selected course, which is what they showed. */}
        <Redirect exact from={PATHS.LANDING_COURSES.URL} to={PATHS.LANDING_CERTIFICATIONS.URL} />
        <Redirect exact from={PATHS.USER_PERFORMANCE.URL} to={{ pathname: PATHS.USER_COURSE_DETAILS.URL, search: '?tab=performance' }} />
        <Redirect exact from={PATHS.USER_EXAM_LOG.URL} to={{ pathname: PATHS.USER_COURSE_DETAILS.URL, search: '?tab=history' }} />

        <Route path={PATHS.LANDING_CERTIFICATIONS.URL} exact component={Catalogue} />
        <Route path={PATHS.LANDING_CERTIFICATIONS_DETAILS.URL} exact component={CertificateDetails} />
        <Route path={PATHS.LANDING_CONTACTUS.URL} exact component={ContactUs} />
        <Route path={PATHS.LANDING_TERMS_AND_CONDITIONS.URL} exact component={TermsAndConditions} />
        <Route path={PATHS.LANDING_PRIVACY_POLICY.URL} exact component={PrivacyPolicy} />
        <Route path={PATHS.LANDING_BADGES.URL} exact component={PublicBadgeRelease} />
        <Route path={PATHS.LANDING_CERT_ATTENDANCE.URL} exact component={PublicCertAttendRelease} />

        <Route path={PATHS.USER_DASHBOARD.URL} exact component={RequireStudent(Dashboard)} />
        <Route path={PATHS.USER_PROFILE.URL} exact component={RequireStudent(Profile)} />
        <Route path={PATHS.USER_SUBSCRIPTIONS.URL} exact component={RequireStudent(Subscriptions)} />
        <Route path={PATHS.USER_COURSE_DETAILS.URL} exact component={RequireStudent(CourseDetails)} />
        <Route path={PATHS.USER_BANK_MCQS.URL} exact component={RequireStudent(McqsBank)} />
        <Route path={PATHS.USER_BANK_ESSAY.URL} exact component={RequireStudent(EssaysBank)} />
        <Route path={PATHS.USER_BANK_TBS.URL} exact component={RequireStudent(TbsBank)} />
        <Route path={PATHS.USER_BANK_FILE.URL} exact component={RequireStudent(FileBank)} />
        <Route path={PATHS.USER_MOCK_EXAM.URL} exact component={RequireStudent(UserMockExam)} />
        <Route path={PATHS.USER_TEST_KNOWLEDGE_EXAM.URL} exact component={RequireStudent(KnowledgeTest)} />
        <Route path={PATHS.USER_FREQ_EXAM.URL} exact component={RequireStudent(UserFreqExam)} />
        <Route path={PATHS.USER_EXAM_REVIEW.URL} exact component={RequireStudent(UserExamReview)} />
        <Route path={PATHS.USER_EXAM_CORRECTION.URL} exact component={RequireStudent(UserExamCorrection)} />
        <Route path={PATHS.USER_EXAM_RESUTLS.URL} exact component={RequireStudent(ExamResults)} />
        <Route path={PATHS.USER_INTERACTIVE_BOOK_DETAILS.URL} exact component={RequireStudent(UserInteractiveBookDetails)} />
        <Route path={PATHS.USER_COURSE_BOOK.URL} exact component={RequireStudent(UserInteractiveBookDetails)} />
        <Redirect exact from={PATHS.USER_INTERACTIVE_BOOKS.URL} to={PATHS.USER_COURSE_DETAILS.URL} />

        {/* Invalid Routes — anything else, including the old sidebar's
            destinations, lands on the dashboard. */}
        <Route>
            <Route path="*" exact component={Dashboard} />
            <Redirect from='*' to={PATHS.USER_DASHBOARD.URL} />
        </Route>

    </Switch>;
};

export default React.memo(StudentStack);
